import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CachedData, StoreDataConfig } from '../models/cache-data.model';
import { UserProfile } from '../models/user-profile.model';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CachingService {
  private cacheData: any = {};
  private dashboardCacheData:any = {}
  userProfile!:UserProfile;
  constructor(
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  /**
   * Method to store data in cache.
   * @param key - Indentifier of the cached data.
   * @param data - Data to be stored in cache.
   * @returns Cached data stored under the indentifier.
   */
  storeCachedData({ key, data, isLangDep = true }: StoreDataConfig) {
    // For data that is not language dependent, store "all" under "lang" key
    this.cacheData[key] = {
      lang: isLangDep ? this.translateService.currentLang : 'all',
      data,
    };
  }

  /**
   * Method to fetch data from cache.
   * @param key - Indentifier of the cached data.
   */
  fetchCachedData<T>(key: string) {
    const fetchedData: CachedData<T> = this.cacheData[key];

    // If not data is present
    if (!fetchedData) {
      return;
    }
    // If data exists but the language is diffrent and not equal to "all", then remove the cached data
    else if (
      fetchedData.lang !== 'all' &&
      fetchedData.lang !== this.translateService.currentLang
    ) {
      this.removeCachedData(key);
      return;
    }

    return fetchedData.data;
  }

  /**
   * Method to remove data from cache.
   * @param key - Indentifier of the cached data.
   */
  removeCachedData(key: string) {
    delete this.cacheData[key];
  }

  storeDashboardData(key:string,value:any){
    if(isPlatformServer(this.platformId)){
      return ;
    }
    this.dashboardCacheData =  JSON.parse(<any>localStorage.getItem('dashboardData')) || {}
    this.dashboardCacheData[key] = this.toBase64Unicode(JSON.stringify(value))
    localStorage.setItem('dashboardData',JSON.stringify(this.dashboardCacheData))
  }

  fetchDashboardData(key:string){
    if(isPlatformServer(this.platformId)){
      return null;
    }
    let dashboardData = JSON.parse(<any>localStorage.getItem('dashboardData'))
    if(!dashboardData[key]) return null;
    return JSON.parse(this.fromBase64Unicode(dashboardData[key]))
  }


  toBase64Unicode(str:string) {
    const utf8Bytes = new TextEncoder().encode(str);
    const base64String = btoa(String.fromCharCode(...utf8Bytes));
    return base64String;
  }

  fromBase64Unicode(base64:string) {
    const binaryString = atob(base64);
    const binaryLength = binaryString.length;
    const utf8Bytes = new Uint8Array(binaryLength);
    for (let i = 0; i < binaryLength; i++) {
        utf8Bytes[i] = binaryString.charCodeAt(i);
    }
    const decodedString = new TextDecoder().decode(utf8Bytes);
    return decodedString;
  }

}
